import React from 'react'
import { useContext } from 'react'
import Navbar from '../../components/navbars/Navbar'
import FullPageCard from '../../components/cards/fullPageCard'
import PreLaunchForm from '../../components/forms/PreLaunchForm'
import './home.css'
import ReactPlayer from 'react-player/lazy'
import Album1 from '../../assets/images/Lux-Specialty-RusticBrass.jpg'
import Wedding from '../../assets/images/Estates.jpg'
import Wedding2 from '../../assets/images/Meridian.jpg'
import Wedding3 from '../../assets/images/Wedding-Photography.jpg'
import ImageBox from '../../assets/images/product/imagebox/ImageBox3.jpg'
import { FaLongArrowAltRight } from "react-icons/fa";
import AdminBar from '../../components/navbars/adminBar'
import { UserContext } from '../../context/UserProvider'

import RequestCallbackButton from '../../components/callbackbutton/RequestCallbackButton'
import Footer from '../../components/Footer'


export default function HomePage() {

    return (
    <div> 
                
        <Navbar/>
        <div className='processSection'>
            <p className='process' style={{padding: '5px', color: 'white'}}>Select Album & Cover</p>
            <FaLongArrowAltRight className='arrowIcon' size={55}/>
            <p className='process' style={{padding: '5px', color: 'white'}}>Order</p>
            <FaLongArrowAltRight  className='arrowIcon' size={55}/>
            <p className='process' style={{padding: '5px', color: 'white'}}>Upload Images</p>
            <FaLongArrowAltRight  className='arrowIcon' size={55}/>
            <p className='process' style={{padding: '5px', color: 'white'}}>We Edit, Design & Ship</p>
        </div>
            
        <FullPageCard 
            image={Album1}
            title='Lux'
            line2='Album Design Included'
            price='From:  $899'
            learnLink='/albums/Lux'  
            orderLink='shop/albums/lux'       
        />
        <FullPageCard 
            image={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Gallery/Photo-Albums-Gallery.jpg'}
            title='Gallery'
            line2='Album Design Included'
            price='From:  $649'
            learnLink='albums/Gallery'  
            orderLink='shop/albums/Gallery'       
        />
        <FullPageCard 
            image={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Economy/Economy-Photo-Album.jpg'}
            title='Economy'
            line2='Album Design Included'
            price='From:  $449'
            learnLink='albums/economy'  
            orderLink='shop/albums/Economy'       
        />
        <FullPageCard 
            image={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Albums/Press-Book/Press-Book-Photo-Album-3.jpg'}
            title='Press Book'
            line2='Album Design Included'
            price='From:  $249'
            learnLink='albums/press-book'  
            orderLink='shop/albums/press-book'       
        />
        
        <FullPageCard 
            image={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Edge-Prints/Edge-Print-1.jpg'}
            title='Edge-Prints'
            line2='Pre-Mounted Metal Prints - Ready to hang!'
            price='From:  $499' 
            learnLink="products/Edge-Prints"
            orderLink="shop/products/Edge-Prints"      
        />
        {/* <FullPageCard 
            image={Wedding2}
            title='Editing (Coming Soon)'
            line2='Add: Beauty Edits, Spot Removal or Our Unique Lux Edit'
            price='From:  $9' 
            // learnLink='/editing'         
            // orderLink="shop/albums/select"
        /> */}
        {/* <FullPageCard 
            image={'https://albums-and-art-product.s3.us-east-1.amazonaws.com/Canvas/canvasNavbar.png'}
            title='Canvas'
            line2='Quality Canvas'
            price='From:  $499' 
            learnLink="products/Canvas"
            orderLink="shop/products/Canvas"      
        /> */}
        {/* <FullPageCard 
            image={Wedding}
            title='Wall Art, Prints and More! (COMING SOON)'
            line2='Metals, Acrylics, Pre-Framed Options'
            price='From:  $299' 
            learnLink=""
            orderLink=""      
        /> */}
        {/* <FullPageCard 
            image={ImageBox}
            title='Image Boxes'
            line2='(Coming Soon!)'
            price='From:  $299'
            learnLink=""
            orderLink=""            
        /> */}
            
      <RequestCallbackButton />
      <Footer/>
</div>
    )
}